import React, { useState, useRef } from 'react';
import './index.less'
export default (props) => {
    const { recordArr } = props
    console.log(recordArr);
    const MONTH = [null, 'Jan.', 'Feb.', 'Mar.', 'Apr.', 'May.', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.']
    // 按捐款人统计 --- 注意目前先用人名做统计，可能会存在重复
    let manarr = []
    let total = 0
    // const datearr = recordArr[0]['开立日'].split('-')
    // const mon = Number(datearr[1])
    let len = recordArr.length
    if (!len) {
        return <h1>暫無數據</h1>
    }
    // 统计经过年月
    let beginDatearr = recordArr[0]['开立日'].split('-')
    let beginYear = beginDatearr[0]
    let beginMon = Number(beginDatearr[1])
    let beginDay = beginDatearr[2]
    let endDatearr = recordArr[len - 1]['开立日'].split('-')
    let endYear = endDatearr[0]
    let endMon = Number(endDatearr[1])
    let endDay = endDatearr[2]
    let monlen = (endYear - beginYear) * 12 + endMon - beginMon + 1
    if (monlen < 12) {
        monlen = 12
    }
    for (let i = 0; i < len; i++) {
        let item = recordArr[i]
        // 判断区域
        let index = manarr.findIndex(item2 => item2.name == item['票据名称'])
        let money = item['票据金额']
        total += money
        // 判断月份 --- 注意可能会跨年份统计，需要确认文档格式,目前限制同一年内
        let datearr = item['开立日'].split('-')
        let year = datearr[0]
        let mon = Number(datearr[1])
        let monlen2 = (year - beginYear) * 12 + mon - 1
        if (index != -1) {

            let newmoney = manarr[index].monarr[monlen2] + money
            manarr[index].monarr[monlen2] = newmoney
            manarr[index].total += money

        } else {

            let monarr = new Array(monlen).fill(0)
            monarr[monlen2] = money
            manarr.push({
                name: item['票据名称'],
                // 当前地区总金额
                total: money,
                monarr: monarr.concat([])
            })
        }


    }
    console.log('最终结果');
    console.log(manarr);
    let j = -1
    return (
        <div className='monthInvoice' id='monthInvoice'>
            <h3>Buddhist Compassion Relief Tzu Chi Foundation Phils., Inc.</h3>
            <h3>Annual Donation List/Submission Report</h3>
            <div><span>For the period of {MONTH[beginMon] + beginDay + ',' + beginYear}-{MONTH[endMon] + endDay + ',' + endYear}</span></div>
            <div className='month2'><span>Commissioner:{recordArr[0]['志工姓名']}</span><span>Currency Unit: PHP</span></div>
            <div className='monTitle2'>
                <table border="1">
                    <thead>
                        <tr>
                            <th>Donor Name</th>
                            {MONTH.slice(1).map((item, index) => {

                                return (
                                    <th key={index}>{item}</th>
                                )
                            })}
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {manarr.map((item, i) => {
                            return (
                                <tr key={i}>
                                    <td>{item.name}</td>
                                    {item.monarr.map((mon, i2) => {
                                        return (
                                            <td key={i2}>{mon}</td>
                                        )
                                    })}
                                    <td>{item.total}</td>
                                </tr>
                            )
                        })}
                    </tbody>

                </table>

            </div>
        </div>
    )
}